/**
 * Validates search results to determine if there are valid suggestions and vehicle matches
 *
 * @param {Object} results - The search results object
 * @param {Array} results.suggestions - Array of suggestion objects
 * @param {Array} results.vehicles - Array of vehicle objects
 * @returns {Object} Object containing hasSuggestions and hasVehicleMatch booleans
 */
export const validateSearchResults = (results) => {
	const hasSuggestions = !!results?.suggestions?.[0]?.facetInfo;

	const hasVehicleMatch = !!results?.vehicles?.length;

	return { hasSuggestions, hasVehicleMatch };
};
